<template>
  <v-card class="sticky">
    <vue-perfect-scrollbar>
      <v-card-text class="scroll-child">
        <v-layout row wrap>
          <v-flex 
            v-for="(item, i) in channelsFilter" 
            class="channelBorder xs12 card--hover"
            :mt-3="i > 0"
            :class="{'activeChannel': item.id === channel}"
            @click="$emit('setChannel', item.id)"
            :key="`channel-card-${i}`">
            <v-layout align-center row wrap>
              <v-flex ml-3 md2>
                <v-icon :class="{'white--text': item.id === channel}"  medium>
                  {{ item.icon }}
                </v-icon>
              </v-flex>
              <v-flex ml-2 md6>
                <p class="channelName">
                  {{ item.name }}
                </p>
                <span class="channelCaption">
                  {{new Intl.NumberFormat('es-VE').format(item.customer)}} clientes
                </span>
                <span class="channelCaption">
                  {{new Intl.NumberFormat('es-VE').format(item.schedules)}} gestiones
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </vue-perfect-scrollbar>
  </v-card>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    channel: {
      type: Number,
      required: true,
    },
    channelsFilter: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style scoped>
.scroll-child {
  height: calc(100vh - 70px);
}
.scroll-child > .layout {
  padding-bottom: 6%;
}
.channelBorder {
  cursor: pointer;
  border: 1px solid #d3d3d3;
  font-size: 20px;
  padding: 5% 0 5% 10%;
}
.sticky {
  position: sticky;
  top: 63px;
}
.channelName {
  font-size: 14px;
  margin-bottom: 0;
}
.activeChannel{
  background: #f57a63;
  color: #fff;
  background: #f57a63;
  color: #fff;
  box-shadow: 0px 4px 15px 1px rgba(0,0,0,0.35);
  border: unset;
}
.channelCaption {
  font-size: 12px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/panelV2/Channels/Channel.vue